<template>
    <div class="settings">
        <div class="container-fluid">
            <div class="row">
                <Menu title="Salon Settings" />
                <div class="col-12 p-0"> 
                    <Settings id="settings_view" 
                    :style="{
                        width : !$store.state.menu_toggle ? 'calc(100% - 70px)' : 'calc(100% - 255px )',
                    }" 
                    ></Settings>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from '@/components/menu_component.vue';
    import Settings from '@/components/settings_component.vue';

    export default {
        name: 'setting_view',
        data() {
            return {
            }
        },
        components: {
            Menu,
            Settings
        }
    }
</script>